/* linguist-generated */
/* eslint-disable */
// Generated code. Do not modify.
// To add additional endpoints, please add them to your api-gateway protos and
// re-run yarn nx run instant-api-hooks-<module>:codegen
//
import { useCallback } from 'react';
import { getBaseUrl } from '../../Profile-menuApiEnvironment';

import {
  useFetchableResource,
  useGetResource,
  useFetch,
  FetchOptions,
  FetchSkippableOptions,
  FetchNonThrowingOverloadOptions,
} from '@cbhq/instant-api-hooks-core/fetch';
import { CONSOLE_PREFIX, CONSOLE_STYLE } from '@cbhq/instant-api-hooks-core/util';

import {
  CoinbaseProfileMenuGetProfileMenuResponseV2,
  getCoinbaseProfileMenuGetProfileMenuResponseV2Errors,
} from '../../types/coinbase/profile_menu/CoinbaseProfileMenuGetProfileMenuResponseV2';

export type ProfileMenuV2Args = {
  clientOptions?: {
    /**
     * project_id is the UUID that identifies a project.
     */
    projectId?: string;

    /**
     * No description provided
     */
    locale?: string;

    /**
     * No description provided
     */
    action?: string;

    /**
     * No description provided
     */
    uiVersion?: string;
  };

  /**
   * No description provided
   */
  polling?: boolean;

  /**
   * product_id optionally filters the returned `resources` (legal entities) down to
those with this cloud/iam product enabled. A SpiceDB shared/product object ID
(e.g. "prime"). Empty means no filtering (all entities are returned, as today).
   */
  productId?: string;
};

export type ProfileMenuV2Result = CoinbaseProfileMenuGetProfileMenuResponseV2;

const validateProfileMenuV2Result = (value: unknown) => {
  const errors = getCoinbaseProfileMenuGetProfileMenuResponseV2Errors(value);
  if (errors.length) {
    console.error(
      CONSOLE_PREFIX,
      CONSOLE_STYLE,
      `API Error: ProfileMenuV2Result data does not match contract.`,
      errors,
    );
  }
};

export const getProfileMenuV2Url = (
  params: ProfileMenuV2Args,
  {
    additionalParams,
    baseUrl,
  }: {
    additionalParams?: Record<string, unknown>;
    baseUrl?: string;
  } = {},
) => {
  const searchParams = new URLSearchParams();
  if (params.clientOptions?.projectId !== null && params.clientOptions?.projectId !== undefined) {
    const val = params.clientOptions?.projectId;
    searchParams.append('client_options.project_id', `${val}`);
  }

  if (params.clientOptions?.locale !== null && params.clientOptions?.locale !== undefined) {
    const val = params.clientOptions?.locale;
    searchParams.append('client_options.locale', `${val}`);
  }

  if (params.clientOptions?.action !== null && params.clientOptions?.action !== undefined) {
    const val = params.clientOptions?.action;
    searchParams.append('client_options.action', `${val}`);
  }

  if (params.clientOptions?.uiVersion !== null && params.clientOptions?.uiVersion !== undefined) {
    const val = params.clientOptions?.uiVersion;
    searchParams.append('client_options.ui_version', `${val}`);
  }

  if (params.polling !== null && params.polling !== undefined) {
    const val = params.polling;
    searchParams.append('polling', `${val}`);
  }

  if (params.productId !== null && params.productId !== undefined) {
    const val = params.productId;
    searchParams.append('product_id', `${val}`);
  }

  if (additionalParams) {
    for (const [key, value] of Object.entries(additionalParams)) {
      if (value !== null && value !== undefined && !searchParams.has(key)) {
        searchParams.append(key, `${value}`);
      }
    }
  }
  const url = `${baseUrl || getBaseUrl()}/api/v2/profile-menu${
    searchParams.toString() === '' ? '' : `?${searchParams}`
  }`;
  return url;
};

/**
 * Fetch ProfileMenuV2
 * @Url /api/v2/profile-menu
 * @Auth Required
 */

export function useGetProfileMenuV2(
  params: ProfileMenuV2Args,
  options: FetchSkippableOptions | FetchNonThrowingOverloadOptions,
): ProfileMenuV2Result | undefined;

export function useGetProfileMenuV2(
  params: ProfileMenuV2Args,
  options?: FetchOptions,
): ProfileMenuV2Result;

export function useGetProfileMenuV2(
  params: ProfileMenuV2Args,
  options?: FetchOptions | FetchSkippableOptions | FetchNonThrowingOverloadOptions,
) {
  const url = getProfileMenuV2Url(params, options);
  const data = useFetch<ProfileMenuV2Result>({ url, ...options });

  if (process.env.NODE_ENV !== 'production') {
    validateProfileMenuV2Result(data);
  }

  return data;
}

/**
 * Access ProfileMenuV2 fetch callback
 */
export const useGetProfileMenuV2Callback = () => {
  const getResource = useGetResource();

  const fetch = useCallback(
    async (params: ProfileMenuV2Args, additionalHeaders?: Record<string, string>) => {
      const url = getProfileMenuV2Url(params);
      const resource = getResource<ProfileMenuV2Result>(url, undefined, additionalHeaders);

      await resource.fetch();
      const data =
        resource.data == null
          ? new Error('FetchableResource completed but no data or error was set')
          : resource.data;

      if (process.env.NODE_ENV !== 'production') {
        validateProfileMenuV2Result(data);
      }

      return data;
    },
    [getResource],
  );

  return fetch;
};

/**
 * Refresh ProfileMenuV2 without throwing to suspense
 * @Url /api/v2/profile-menu
 * @Auth Required
 */
export const useRefreshProfileMenuV2 = (
  params: ProfileMenuV2Args,
  additionalParams: {
    disableCamelize?: boolean;
    additionalHeaders?: Record<string, string>;
  } = {},
) => {
  const { disableCamelize, additionalHeaders } = additionalParams;
  const url = getProfileMenuV2Url(params);

  const { fetch } = useFetchableResource<ProfileMenuV2Result>(
    url,
    disableCamelize,
    additionalHeaders,
  );

  return fetch;
};

/**
 * Remove ProfileMenuV2 from cache without refetching. Subscribed components may refresh and throw to suspense.
 * @Url /api/v2/profile-menu
 */
export const useClearProfileMenuV2 = (params: ProfileMenuV2Args) => {
  const url = getProfileMenuV2Url(params);

  const { clear } = useFetchableResource<ProfileMenuV2Result>(url);

  return clear;
};

export const useWithOptimisticProfileMenuV2Updates = (params: ProfileMenuV2Args) => {
  const url = getProfileMenuV2Url(params);

  const { optimisticUpdate } = useFetchableResource<ProfileMenuV2Result>(url);

  return optimisticUpdate;
};
